import PQueue from "p-queue";

export const cahceQueue = new PQueue({ concurrency: 4, autoStart: true });

const getResource = async (url?: string | null) => {
	if (!url) return null;
	const cache = await caches.open("media");
	const cached = await cache.match(url);
	if (cached) return cached;
	const response = await fetch(url);
	if (!response.ok) return null;
	return response;
};

const deleteResource = async (url?: string | null) => {
	if (!url) return null;
	const cache = await caches.open("media");
	await cache.delete(url);
};

export const addToCache = async (url?: string | null) => {
	if (!url) return null;
	return await cahceQueue.add(() => getResource(url));
};

export const deleteFromCache = async (url?: string | null) => {
	if (!url) return null;
	return await cahceQueue.add(() => deleteResource(url));
};
